import React from 'react';
import { withStyles } from '@material-ui/core';

import styles from './Checkbox.styles';
import { Checkbox, CheckboxProps } from './Checkbox';

export type Props = CheckboxProps & { classes?: Partial<Record<keyof ReturnType<typeof styles>, string>> };

export default withStyles(styles)(Checkbox) as React.ComponentClass<Props>;
